import type { Accessory, CatalogItem, Furniture, Plant, Pot } from "./model";

export const plants: Plant[] = [
  {
    id: "plant-lady-palm",
    name: "Cau tiểu trâm",
    scientificName: "Rhapis excelsa",
    type: "plant",
    groupId: "canopy",
    unitPrice: 520000,
    widthCm: 48,
    depthCm: 48,
    heightCm: 120,
    mediaKey: "lady-palm",
    description: "Tán đứng gọn, tạo lớp nền cao mà không lấn quá nhiều lối đi.",
    styleTags: ["tán", "râm", "nhiệt đới"],
    lights: ["shade", "morning", "partial"],
    care: "medium",
    petSafety: "safe",
    childSafety: "safe",
    windTolerance: 2,
    wateringPerWeek: 2,
    careMinutesPerWeek: 8,
    potSize: "large",
    careNote: "Giữ ẩm vừa, lau bụi lá mỗi hai tuần.",
  },
  {
    id: "plant-boston-fern",
    name: "Dương xỉ Boston",
    scientificName: "Nephrolepis exaltata",
    type: "plant",
    groupId: "soft",
    unitPrice: 260000,
    widthCm: 42,
    depthCm: 42,
    heightCm: 48,
    mediaKey: "boston-fern",
    description: "Lá rủ dày làm mềm mép chậu, hợp nơi có nắng lọc.",
    styleTags: ["rủ", "râm", "nhiệt đới"],
    lights: ["shade", "morning"],
    care: "medium",
    petSafety: "safe",
    childSafety: "safe",
    windTolerance: 1,
    wateringPerWeek: 3,
    careMinutesPerWeek: 7,
    potSize: "medium",
    careNote: "Không để giá thể khô trắng; tránh nắng trưa.",
  },
  {
    id: "plant-birdnest-fern",
    name: "Ổ phụng",
    scientificName: "Asplenium nidus",
    type: "plant",
    groupId: "soft",
    unitPrice: 320000,
    widthCm: 45,
    depthCm: 45,
    heightCm: 55,
    mediaKey: "birdnest-fern",
    description: "Lá bản lớn tạo điểm tĩnh cho ban công râm sáng.",
    styleTags: ["râm", "texture", "nhiệt đới"],
    lights: ["shade", "morning"],
    care: "medium",
    petSafety: "safe",
    childSafety: "safe",
    windTolerance: 1,
    wateringPerWeek: 2,
    careMinutesPerWeek: 6,
    potSize: "medium",
    careNote: "Tưới quanh mép chậu, tránh đọng nước trong nõn.",
  },
  {
    id: "plant-spider",
    name: "Lan chi",
    scientificName: "Chlorophytum comosum",
    type: "plant",
    groupId: "trailing",
    unitPrice: 140000,
    widthCm: 32,
    depthCm: 32,
    heightCm: 34,
    mediaKey: "spider-plant",
    description: "Dải lá sáng màu, chịu điều kiện rộng và phục hồi nhanh.",
    styleTags: ["rủ", "nền", "râm"],
    lights: ["shade", "morning", "partial"],
    care: "light",
    petSafety: "safe",
    childSafety: "safe",
    windTolerance: 2,
    wateringPerWeek: 2,
    careMinutesPerWeek: 4,
    potSize: "small",
    careNote: "Tưới khi mặt chậu se khô, tỉa đầu lá nâu.",
  },
  {
    id: "plant-peperomia",
    name: "Trường sinh xanh",
    scientificName: "Peperomia obtusifolia",
    type: "plant",
    groupId: "soft",
    unitPrice: 180000,
    widthCm: 28,
    depthCm: 28,
    heightCm: 32,
    mediaKey: "peperomia",
    description: "Lá dày bóng, dáng gọn và cần ít nước hơn nhóm dương xỉ.",
    styleTags: ["nền", "texture", "râm"],
    lights: ["shade", "morning", "partial"],
    care: "light",
    petSafety: "safe",
    childSafety: "safe",
    windTolerance: 2,
    wateringPerWeek: 1,
    careMinutesPerWeek: 3,
    potSize: "small",
    careNote: "Để khô 2–3 cm mặt giá thể trước lần tưới tiếp.",
  },
  {
    id: "plant-calathea",
    name: "Đuôi công",
    scientificName: "Goeppertia orbifolia",
    type: "plant",
    groupId: "soft",
    unitPrice: 280000,
    widthCm: 38,
    depthCm: 38,
    heightCm: 48,
    mediaKey: "calathea",
    description: "Vân lá tạo nhịp đồ họa, dành cho góc râm và kín gió.",
    styleTags: ["râm", "texture", "nền"],
    lights: ["shade"],
    care: "enthusiast",
    petSafety: "safe",
    childSafety: "safe",
    windTolerance: 1,
    wateringPerWeek: 3,
    careMinutesPerWeek: 10,
    potSize: "medium",
    careNote: "Cần ẩm đều và tránh gió nóng; ưu tiên nước ít khoáng.",
  },
  {
    id: "plant-rosemary",
    name: "Hương thảo",
    scientificName: "Salvia rosmarinus",
    type: "plant",
    groupId: "edible",
    unitPrice: 180000,
    widthCm: 32,
    depthCm: 32,
    heightCm: 46,
    mediaKey: "rosemary",
    description: "Thân gỗ thơm, hợp nắng và chậu thoát nước nhanh.",
    styleTags: ["thơm", "ăn được", "mộc"],
    lights: ["morning", "partial", "harsh"],
    care: "medium",
    petSafety: "safe",
    childSafety: "safe",
    windTolerance: 3,
    wateringPerWeek: 2,
    careMinutesPerWeek: 10,
    potSize: "medium",
    careNote: "Không để úng; bấm ngọn nhẹ sau thu hoạch.",
  },
  {
    id: "plant-basil",
    name: "Húng quế",
    scientificName: "Ocimum basilicum",
    type: "plant",
    groupId: "edible",
    unitPrice: 120000,
    widthCm: 28,
    depthCm: 28,
    heightCm: 38,
    mediaKey: "basil",
    description: "Tán thơm dùng bếp, cần thu hái đều để giữ dáng.",
    styleTags: ["thơm", "ăn được", "mộc"],
    lights: ["morning", "partial"],
    care: "enthusiast",
    petSafety: "safe",
    childSafety: "safe",
    windTolerance: 2,
    wateringPerWeek: 4,
    careMinutesPerWeek: 10,
    potSize: "small",
    careNote: "Tưới sáng, bấm hoa để cây tiếp tục ra lá.",
  },
  {
    id: "plant-mint",
    name: "Bạc hà",
    scientificName: "Mentha × piperita",
    type: "plant",
    groupId: "edible",
    unitPrice: 120000,
    widthCm: 30,
    depthCm: 30,
    heightCm: 32,
    mediaKey: "mint",
    description: "Mảng lá thơm khỏe, nên trồng riêng chậu để kiểm soát rễ.",
    styleTags: ["thơm", "ăn được", "mộc"],
    lights: ["morning", "partial"],
    care: "medium",
    petSafety: "caution",
    childSafety: "safe",
    windTolerance: 2,
    wateringPerWeek: 4,
    careMinutesPerWeek: 8,
    potSize: "small",
    careNote: "Giữ ẩm, cắt gọn mỗi tuần; không để thú cưng nhai lá.",
  },
  {
    id: "plant-calamansi",
    name: "Tắc lùn",
    scientificName: "Citrus × microcarpa",
    type: "plant",
    groupId: "edible",
    unitPrice: 680000,
    widthCm: 55,
    depthCm: 55,
    heightCm: 110,
    mediaKey: "calamansi",
    description: "Cây quả lùn tạo tâm điểm theo mùa, cần nhiều nắng.",
    styleTags: ["ăn được", "mộc", "tán"],
    lights: ["partial", "harsh"],
    care: "enthusiast",
    petSafety: "unsafe",
    childSafety: "caution",
    windTolerance: 2,
    wateringPerWeek: 3,
    careMinutesPerWeek: 12,
    potSize: "large",
    careNote: "Bón theo mùa, giữ thoát nước; lá/tinh dầu không phù hợp thú cưng.",
  },
  {
    id: "plant-bougainvillea",
    name: "Bông giấy lùn",
    scientificName: "Bougainvillea glabra",
    type: "plant",
    groupId: "canopy",
    unitPrice: 390000,
    widthCm: 46,
    depthCm: 46,
    heightCm: 85,
    mediaKey: "bougainvillea",
    description: "Màu hoa bền nắng và ít nước, nhưng có gai cần đặt có kiểm soát.",
    styleTags: ["hoa", "mộc", "tán"],
    lights: ["partial", "harsh"],
    care: "medium",
    petSafety: "caution",
    childSafety: "unsafe",
    windTolerance: 3,
    wateringPerWeek: 2,
    careMinutesPerWeek: 7,
    potSize: "large",
    careNote: "Cần nắng, cắt tỉa có găng và tránh tầm với trẻ nhỏ.",
  },
  {
    id: "plant-pothos",
    name: "Trầu bà vàng",
    scientificName: "Epipremnum aureum",
    type: "plant",
    groupId: "trailing",
    unitPrice: 220000,
    widthCm: 34,
    depthCm: 34,
    heightCm: 42,
    mediaKey: "pothos",
    description: "Dây rủ bền và dễ tạo mảng, chỉ dùng khi không có ràng buộc thú cưng.",
    styleTags: ["rủ", "râm", "nhiệt đới"],
    lights: ["shade", "morning", "partial"],
    care: "light",
    petSafety: "unsafe",
    childSafety: "caution",
    windTolerance: 2,
    wateringPerWeek: 1,
    careMinutesPerWeek: 4,
    potSize: "small",
    careNote: "Để cao ngoài tầm với; nhựa cây có thể gây kích ứng.",
  },
];

export const pots: Pot[] = [
  {
    id: "pot-lime-rect",
    name: "Bồn vôi dài 110",
    type: "pot",
    unitPrice: 1450000,
    widthCm: 110,
    depthCm: 32,
    heightCm: 38,
    mediaKey: "pot-rect",
    description: "Bồn composite nhẹ phủ vôi mờ, có chân kê và lỗ thoát.",
    styleTags: ["nhiệt đới", "râm"],
    size: "large",
    material: "composite phủ vôi",
    color: "kem rêu",
    selfWatering: false,
    hanging: false,
  },
  {
    id: "pot-selfwater-32",
    name: "Chậu tự tưới Mây 32",
    type: "pot",
    unitPrice: 680000,
    widthCm: 32,
    depthCm: 32,
    heightCm: 38,
    mediaKey: "pot-round",
    description: "Chậu nhẹ có khoang nước và chỉ báo mức đơn giản.",
    styleTags: ["nhiệt đới", "râm", "mộc"],
    size: "medium",
    material: "composite",
    color: "xám ấm",
    selfWatering: true,
    hanging: false,
  },
  {
    id: "pot-terracotta-32",
    name: "Chậu đất nung 32",
    type: "pot",
    unitPrice: 320000,
    widthCm: 32,
    depthCm: 32,
    heightCm: 31,
    mediaKey: "pot-terra",
    description: "Đất nung thành dày, lỗ thoát lớn, có đĩa hứng.",
    styleTags: ["mộc"],
    size: "medium",
    material: "đất nung",
    color: "đất đỏ",
    selfWatering: false,
    hanging: false,
  },
  {
    id: "pot-charcoal-40",
    name: "Chậu than 40",
    type: "pot",
    unitPrice: 560000,
    widthCm: 40,
    depthCm: 40,
    heightCm: 36,
    mediaKey: "pot-charcoal",
    description: "Chậu composite bề mặt khoáng mờ cho nhóm cây râm.",
    styleTags: ["râm", "nhiệt đới"],
    size: "medium",
    material: "composite",
    color: "than rêu",
    selfWatering: false,
    hanging: false,
  },
  {
    id: "pot-tall-cream",
    name: "Chậu cao Búp 42",
    type: "pot",
    unitPrice: 780000,
    widthCm: 42,
    depthCm: 42,
    heightCm: 62,
    mediaKey: "pot-tall",
    description: "Dáng cao đặt sát tường, phù hợp cây tạo tán.",
    styleTags: ["nhiệt đới", "râm"],
    size: "large",
    material: "composite",
    color: "kem",
    selfWatering: false,
    hanging: false,
  },
  {
    id: "pot-hanging-small",
    name: "Chậu treo trong 24",
    type: "pot",
    unitPrice: 260000,
    widthCm: 24,
    depthCm: 24,
    heightCm: 22,
    mediaKey: "pot-hanging",
    description: "Chậu treo phía trong ban công, dùng cáp khóa và khay hứng.",
    styleTags: ["nhiệt đới", "mộc"],
    size: "small",
    material: "composite",
    color: "kem",
    selfWatering: false,
    hanging: true,
  },
];

export const furniture: Furniture[] = [
  {
    id: "furn-fold-chair",
    name: "Ghế đọc gập Nan",
    type: "furniture",
    unitPrice: 1890000,
    widthCm: 62,
    depthCm: 68,
    heightCm: 82,
    mediaKey: "chair",
    description: "Ghế gỗ dầu gập được, nệm rời cất trong nhà.",
    styleTags: ["nhiệt đới", "mộc"],
    minDepthCm: 115,
    foldable: true,
  },
  {
    id: "furn-round-table",
    name: "Bàn trà Tròn 42",
    type: "furniture",
    unitPrice: 980000,
    widthCm: 42,
    depthCm: 42,
    heightCm: 48,
    mediaKey: "table-round",
    description: "Bàn gỗ tròn nhẹ, vừa cốc trà và một cuốn sách.",
    styleTags: ["nhiệt đới", "mộc", "râm"],
    minDepthCm: 100,
    foldable: false,
  },
  {
    id: "furn-slim-bench",
    name: "Băng ghế Mảnh 92",
    type: "furniture",
    unitPrice: 2800000,
    widthCm: 92,
    depthCm: 44,
    heightCm: 52,
    mediaKey: "bench",
    description: "Băng ghế gọn cho hai người, có khoang cất đồ khô.",
    styleTags: ["nhiệt đới", "mộc"],
    minDepthCm: 130,
    foldable: false,
  },
  {
    id: "furn-tea-set",
    name: "Bộ bàn gập Hai Mùa",
    type: "furniture",
    unitPrice: 3400000,
    widthCm: 76,
    depthCm: 76,
    heightCm: 74,
    mediaKey: "tea-set",
    description: "Bàn vuông và hai ghế gập cho góc cây ăn được.",
    styleTags: ["mộc"],
    minDepthCm: 140,
    foldable: true,
  },
  {
    id: "furn-low-chair",
    name: "Ghế thấp Đan",
    type: "furniture",
    unitPrice: 2200000,
    widthCm: 66,
    depthCm: 72,
    heightCm: 70,
    mediaKey: "low-chair",
    description: "Ghế tựa thấp bằng dây đan chịu ngoài trời có mái.",
    styleTags: ["râm"],
    minDepthCm: 120,
    foldable: false,
  },
];

export const accessories: Accessory[] = [
  {
    id: "acc-wall-light",
    name: "Đèn hắt Vệt Nắng",
    type: "accessory",
    unitPrice: 620000,
    widthCm: 18,
    depthCm: 12,
    heightCm: 16,
    mediaKey: "wall-light",
    description: "Đèn hắt ấm minh họa; nguồn điện thực tế cần được khảo sát.",
    styleTags: ["nhiệt đới", "mộc", "râm"],
    minDepthCm: 70,
    windSafe: true,
    essential: false,
  },
  {
    id: "acc-trellis",
    name: "Giàn nan trong 60",
    type: "accessory",
    unitPrice: 780000,
    widthCm: 60,
    depthCm: 8,
    heightCm: 120,
    mediaKey: "trellis",
    description: "Giàn nan lắp mặt tường bên trong, không buộc vào lan can.",
    styleTags: ["nhiệt đới", "mộc"],
    minDepthCm: 80,
    windSafe: true,
    essential: false,
  },
  {
    id: "acc-watering-can",
    name: "Bình tưới vòi dài",
    type: "accessory",
    unitPrice: 290000,
    widthCm: 42,
    depthCm: 18,
    heightCm: 28,
    mediaKey: "watering",
    description: "Bình 4 lít, vòi dài để tưới sát gốc.",
    styleTags: ["mộc", "nhiệt đới", "râm"],
    minDepthCm: 70,
    windSafe: true,
    essential: true,
  },
  {
    id: "acc-drip-kit",
    name: "Bộ tưới nhỏ giọt 8 điểm",
    type: "accessory",
    unitPrice: 1350000,
    widthCm: 24,
    depthCm: 18,
    heightCm: 12,
    mediaKey: "drip",
    description: "Bộ mô phỏng cho nguồn nước tại ban công; cần lắp đặt thực tế.",
    styleTags: ["mộc", "nhiệt đới"],
    minDepthCm: 80,
    windSafe: true,
    essential: false,
  },
  {
    id: "acc-pot-feet",
    name: "Bộ chân kê 6 chậu",
    type: "accessory",
    unitPrice: 240000,
    widthCm: 10,
    depthCm: 10,
    heightCm: 3,
    mediaKey: "feet",
    description: "Kê đáy chậu khỏi mặt sàn để hỗ trợ thoát nước.",
    styleTags: ["mộc", "nhiệt đới", "râm"],
    minDepthCm: 50,
    windSafe: true,
    essential: true,
  },
  {
    id: "acc-slim-storage",
    name: "Tủ mảnh chống ẩm",
    type: "accessory",
    unitPrice: 2400000,
    widthCm: 72,
    depthCm: 34,
    heightCm: 88,
    mediaKey: "storage",
    description: "Tủ thấp chứa dụng cụ, cần đặt trong vùng có mái che.",
    styleTags: ["mộc", "nhiệt đới"],
    minDepthCm: 130,
    windSafe: false,
    essential: false,
  },
];

export const catalog: CatalogItem[] = [...plants, ...pots, ...furniture, ...accessories];
export const catalogById = new Map(catalog.map((item) => [item.id, item]));
